module.exports = __webpack_public_path__ + "img/ch7pic5.6a0a51b8.png";